import styled, { css } from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';
import { MTabControlAlignment } from './MTabControl.types';

const { spacers, border } = baseVariables;

export interface WrapperProps {
  $active?: boolean;
  $alignment?: MTabControlAlignment;
}

const activeStyles = css`
  border-block-end: ${toRem(3)} ${border.borderStyleDefault} var(--t-interactive-accent-color);
`;

const inactiveStyles = css`
  border-block-end: ${toRem(3)} ${border.borderStyleDefault} transparent;
`;

const getAlignItems = (alignment?: MTabControlAlignment) => {
  switch (alignment) {
    case MTabControlAlignment.Center:
      return 'center';
    case MTabControlAlignment.Left:
    default:
      return 'flex-start';
  }
};

export const Wrapper = styled.button<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${props => getAlignItems(props.$alignment)};
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  padding-block: 0 ${spacers?.spacers?.[3] ?? '1rem'};
  padding-inline: 0;
  margin: 0;
  background: transparent;
  border: none;
  cursor: pointer;

  ${props => (props.$active ? activeStyles : inactiveStyles)}

  &:focus-visible {
    outline: 2px solid var(--t-brand-alt-color);
    outline-offset: 2px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const TextBlock = styled.div<{ $alignment?: MTabControlAlignment; $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${props => getAlignItems(props.$alignment)};
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};

  .m-tab-control-label {
    color: ${props => (props.$active ? 'var(--t-brand-fg-color)' : 'var(--t-brand-alt-color)')};
  }

  .m-tab-control-description {
    color: var(--t-brand-alt-color);
  }
`;
